/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchsuggestion.js
 */

$.namespace("SCS.searchsuggestion");

/**
 * Initialize
 */
SCS.searchsuggestion.init = function(resourcePath) {
	$(document).ready(function() {
		var url;
		var searchvalue;
		$("#search").keyup(function() {
			searchvalue = encodeURIComponent(this.value);
			var cat = $("#categoryTag option:selected").text();
			url = resourcePath + ".suggestion." + searchvalue + ".json";
		});
		$("#search").autocomplete({
			source : loadFromAjax,
			minLength : 3,
			appendTo : "#search_results_div"
		});
		function loadFromAjax(request, response) {
			$.ajax({
				url : url,
				timeout : 10000,
				dataType : 'json',
				success : function(data) {
					response(data);
				}
			});
		}
	});
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/searchsuggestion.js
// module id = 342
// module chunks = 0